import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoHolisticlocksGetRes } from "./abst/DtoHolisticlocksGetRes";

export class DtoHolisticlocksGetResImple extends DtoHolisticlocksGetRes {
  public pager = new DtoApiPager();
}
